import React, { FunctionComponent } from "react"
import { graphql } from "gatsby"
import { MainContent } from "components/commons/commons"
import { MainLayout } from "components/Layout/Layout"
import { ArticleContent } from "components/ArticleContent/ArticleContent"
import ImgWrapper from "components/image/ImageWrapper"
import styled from "styled-components"
import { colors } from "src/styles/colors"
import { RecomendedArticles } from "components/RecomendedArticles/RecomendedArticles"
import BG from "assets/bg.png"
import BGMOB from "assets/bg-mobile.png"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { CTASection } from "components/CTA/CTA"
import "../styles/base.less"
import { FooterStrip } from "components/Footer/footer-strip"
import { ExitIntentModal } from 'components/ExitIntentModal/ExitIntentModal';

const ArticleTemplate: FunctionComponent<any> = ({
  data: { contentfulArticle, contentfulArticleCta },
}) => {
  const { minTablet } = useBreakpoints()

  return (
    <MainLayout
      title={contentfulArticle.seo.metatitle}
      description={contentfulArticle.seo.metadescription}
      image={contentfulArticle.titleImage.fluid.src}
      bg
    >
      <ExitIntentModal/>
      <MainContent>
        <ImgWrapper
          style={{ width: minTablet ? 1170 : "100%" }}
          img={contentfulArticle.titleImage}
        />
        <ArticleContent {...contentfulArticle} />
      </MainContent>
      {contentfulArticle.recommendedArticles && (
        <Background minTablet={minTablet} src={colors.lightTeal}>
          <MainContent>
            <RecomendedArticles
              articles={contentfulArticle.recommendedArticles}
            />
          </MainContent>
        </Background>
      )}
      <Background minTablet={minTablet} src={`url(${minTablet ? BG : BGMOB})`}>
        <MainContent>
          <CTASection {...contentfulArticleCta} />
        </MainContent>
      </Background>
      <MainContent>
        <FooterStrip />
      </MainContent>
    </MainLayout>
  )
}

export default ArticleTemplate

const Background = styled.div<any>`
  background: ${({ src }) => (src ? src : colors.white)};
  background-repeat: no-repeat;
  background-size: cover;
  min-height: ${({ minTablet }) => (minTablet ? "500px" : "769px")};
  width: 100%;
  height: 100%;
`

export const pageQuery = graphql`
  query ArticleById($id: String!) {
    contentfulArticle(id: { eq: $id }) {
      createdAt(formatString: "DD MMM YYYY", locale: "de")
      seo {
        metatitle
        metadescription
      }
      title
      subtitle {
        subtitle
      }
      titleImage {
        fluid(maxWidth: 1200, maxHeight: 320, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      author {
        name
        description {
          description
        }
        image {
          fluid(maxWidth: 160, maxHeight: 160, quality: 70) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
      content {
        content
      }
      recommendedArticles {
        ... on ContentfulArticle {
          slug
          title
          author {
            name
          }
          createdAt(formatString: "DD MMM YYYY", locale: "de")
          subtitle {
            subtitle
          }
          outsideImage {
            fluid(maxWidth: 360, maxHeight: 230, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
    contentfulArticleCta {
      firstText
      secondTest
      firstButtonText
      firstButtonLink
      secondButtonText
      secondButtonLink
    }
  }
`
